import SecureConnectionDisplay from './SecureConnectionDisplay';

export default SecureConnectionDisplay;
